module.exports = __webpack_public_path__ + "img/13.7ece4042.jpg";